<template>
  <div class="dashboard-chart-pie">
    <h2 v-html="charttitle"></h2>
    <div class="chart-components-container" :style="'height:' + chartheight + ';'">
      <div class="chart-components-content" :style="'height:' + chartheight + ';'" :id="chartid"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PieChart',

  props: {
    chartheight: String,
    charttitle: String,
    chartid: String,
    legendtype: String,
    chartdata: {
      type: Object
    }
  },
  created() {
    this.$nextTick(() => {
      this.initPieChart(this.chartdata)
    });
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.initPieChart(this.chartdata)
      });
    },
  },

  methods: {
    initPieChart: function(chartdata){
      if(document.getElementById(this.chartid) === null) return
      let ec = this.$echarts
      let myBarChart = ec.init(document.getElementById(this.chartid))
      let _legend = {}
      let _center = []
      if(this.legendtype === 'horizontal'){
        _legend = {
          orient: this.legendtype,
          bottom: '0',
          left: 'center',
        }
        _center = ['50%', '45%']
      }
      if(this.legendtype === 'vertical'){
        _legend = {
          orient: this.legendtype,
          top: 'middle',
          right: '0',
        }
        _center = ['30%', '50%']
      }
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)'
        },
        legend: Object.assign(_legend, {
          icon: 'pin',
          data: chartdata.legendData,
          formatter: function (name) {
            return ec.format.truncateText(name, 80, '12px Microsoft Yahei', '…');
          }
        }),
        series: [
          {
            type: 'pie',
            radius: '60%',
            center: _center,
            data: chartdata.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false
              }
            },
          }
        ],
        color: chartdata.color ? chartdata.color : ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    }
  }
}
</script>
